var React = require('react');

function PlusSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 13h-3v3c0 .6-.4 1-1 1s-1-.4-1-1v-3H8c-.6 0-1-.4-1-1s.4-1 1-1h3V8c0-.6.4-1 1-1s1 .4 1 1v3h3c.6 0 1 .4 1 1s-.4 1-1 1z"}));
}

PlusSmall.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = PlusSmall;

PlusSmall.default = PlusSmall;
